import { Component, OnInit } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { MarketronPrerollCreativeComponent } from '../marketron-preroll-creative/marketron-preroll-creative.component';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-marketron-audio-creative',
	styleUrls: ['../marketron-preroll-creative/marketron-preroll-creative.component.css'],
	templateUrl: './marketron-audio-creative.component.html'
})
export class MarketronAudioCreativeComponent extends MarketronPrerollCreativeComponent implements OnInit {
	constructor() {
		super();
		EmitterService.get('PLAY_SELECTED_RADIO_CREATIVE').subscribe((creative) => {
			if (creative && (creative.isAudioCreative || creative.audioURL)) {
				for (let i = 0; i < jQuery('.audioCreativeTag').length; i++) {
					jQuery('.audioCreativeTag')[i].pause();
					jQuery('.audioCreativeTag')[i].currentTime = 0;
				}
			}
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
}
